import { RouteConfig } from 'vue-router'

const routes: RouteConfig[] = [
  {
    path: '/',
    component: () => import('layouts/main-layout.vue'),
    meta: { requiresAuth: true, mainLayout: true },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('pages/home-page.vue')
      }
    ]
  },
  {
    path: '/',
    component: () => import('layouts/simple-layout.vue'),
    children: [
      {
        path: 'sign-in',
        name: 'signIn',
        component: () => import('pages/auth-page.vue'),
        children: [
          {
            path: '/change-pass',
            name: 'changePass',
            component: () => import('pages/change-pass-page.vue'),
            props: true
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: () => import('pages/error-page.vue')
  }
]

export default routes
